import { createContext } from 'react'

import type {
  PenetapanPegawaiPSItem,
  PenetapanPegawaiList,
  PenetapanPegawaiMeta,
} from 'types/kinerja-tim-penilai-ps'

export type TableContextType = {
  items?: Array<PenetapanPegawaiPSItem>
  data: PenetapanPegawaiList | undefined
  meta: PenetapanPegawaiMeta | undefined
  pengawasSekolahList: PenetapanPegawaiPSItem[]
  isFetching?: boolean
  selectedIds?: Set<string>
  selectableIds?: Array<string>
  hasOngoingAction?: boolean
  onToggle?: (pengawasSekolahId: string, isChecked: boolean) => void
  onToggleAll?: (isChecked: boolean) => void
  onSetHasOngoingAction?: (hasOngoing: boolean) => void // Alternative name
  isAllSentToPPK?: boolean
}

export const TableContext = createContext<TableContextType>({
  data: undefined,
  meta: {
    offset: 0,
    limit: 10,
    total: 0,
    totalSentToPpk: 0,
  },
  pengawasSekolahList: [],
})
